// extracted by mini-css-extract-plugin
export default {"buttons-container":"FederatedSignupView_buttons-container__ohFdw","align-center":"FederatedSignupView_align-center__8BXND","buttonSection":"FederatedSignupView_buttonSection__i3ZTF"};